import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { Suspense } from 'react'
import { AppLoader } from '~/components/loader'
import { getAuthToken } from '~/helpers/sessionHelpers'

import { Toaster, TooltipProvider } from '@hap/components'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    if (!getAuthToken()) {
      throw redirect({
        to: '/login',
        search: location.href === '/' ? undefined : { redirect: location.href },
        replace: true,
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <TooltipProvider>
      <Toaster />
      <Suspense fallback={<AppLoader />}>
        <Outlet />
      </Suspense>
    </TooltipProvider>
  )
}
